import { bool, crudTable, index, integer, text } from "@-/dev.improve.haniverse.lib.database.table";

export const collectionTable = crudTable(
  "collection",
  {
    // Optional emoji icon for the collection, stored as the raw grapheme (e.g.
    // "📚"). Persisting the literal character — rather than a key into a preset
    // set — means future changes to any icon presets never invalidate a user's
    // existing choice.
    icon: text("icon"),
    isFavorites: bool("is_favorites").notNull().default(false),
    name: text("name").notNull(),
    // User-defined ordering for the deck list page's drag-to-reorder. Existing
    // rows default to 0, so `createdAt` is the stable tiebreaker on first sort.
    sortOrder: integer("sort_order").notNull().default(0),
    // A parent id, not a FOREIGN KEY: see `ACTOR_TABLE_PARENTS` (the cloud copy would enforce one).
    userId: text("user_id"),
  },
  // `userId` backs the `user.collections` relation join; `isFavorites` backs the
  // `findFirst({ where: { isFavorites: true } })` favorites-collection lookups.
  //
  // The Favorites collection is a singleton by its id: it is always `FAVORITES_COLLECTION_ID`, so
  // every device creates the same row. No unique index guards `is_favorites`, and none may be
  // added (sync cannot resolve a unique conflict).
  (table) => [
    index("collection_user_id_idx").on(table.userId),
    index("collection_is_favorites_idx").on(table.isFavorites),
  ],
);
export type Collection = typeof collectionTable.$inferSelect;
